module.exports = __webpack_public_path__ + "static/media/Institucional-2.2e72d439.jpg";